/**
 * Display helpers on top of `money.ts`. Do not add a second VAT formula here
 * (#1708) — `netToGrossCents` / `grossToNetCents` are the only conversions.
 */

import { netToGrossCents } from './money';

export const DEFAULT_VAT_PERCENT = 25.5;

/** VAT portion (in cents) of a net, VAT-exclusive amount, rounded to whole cents. */
export function vatCentsFromNet(netCents: number, vatPercent: number = DEFAULT_VAT_PERCENT): number {
  if (!Number.isFinite(netCents)) return 0;
  return netToGrossCents(netCents, vatPercent) - Math.round(netCents);
}

/** Gross (VAT-inclusive) amount in cents for a net, VAT-exclusive amount. */
export function grossCentsFromNet(netCents: number, vatPercent: number = DEFAULT_VAT_PERCENT): number {
  return netToGrossCents(netCents, vatPercent);
}

export { netToGrossCents };

/**
 * Compact VAT rate for staff UI, e.g. 25.5 → "25,5%". Uses a comma so the
 * displayed rate matches Finnish tenant rate labels (`25,5 %`).
 */
export function formatVatPercent(percent: number): string {
  return `${String(percent).replace('.', ',')}%`;
}
